
import Vue from 'vue';
import { Component, Prop /*Watch*/ } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import FilterBarContentType from '@/components/filter-bar/FilterBarContentType.vue';

import { CollectionType } from '@/enums/collection-type';
import { WebLocale } from '@/enums/web-locale';

import Provider from '@/interfaces/provider';
import { PopularTabType } from '@/interfaces/titles';

import { FilterCollection } from '@/stores/filter.store';
import { UserSettings } from '@/stores/user.store';

import BasicButton from '@/ui-components/BasicButton.vue';
import FilterBarPopularProvider from './FilterBarPopularProvider.vue';
import FilterBarContentTypeSeo from '@/components/filter-bar/seo/FilterBarContentTypeSeo.vue';

import ContentHeader from '@/components/content-header/ContentHeader.vue';
// import { loadProviderPlan } from './helper';
import Top10Titles from './Top10Titles.vue';
const ProviderPlans = () => import(/* webpackChunkName: "provider-plans" */ './ProviderPlans.vue');

const Constant = namespace('constant');
const Routing = namespace('routing');

interface Plan {
	provider: string;
	title: string;
	monthly?: string;
	yearly?: string;
	simultaneous_streams: number | string;
	video_quality: string;
	link: string;
	otherServices: string;
	content: string;
}

@Component({
	components: {
		FilterBarContentTypeSeo,
		FilterBarContentType,
		Top10Titles,
		ProviderPlans,
		BasicButton,
		ContentHeader,
		FilterBarPopularProvider,
	},
})
export default class ProviderModule extends Vue {
	@Prop() collectionType: CollectionType;
	@Prop() currentFilters: FilterCollection;
	@Prop() isFiltersVisible: boolean;
	@Prop({ default: false }) providersInMenu: boolean;
	@Prop() webLocale: WebLocale;
	@Prop() userSettings: UserSettings;
	@Prop() provider: Provider;
	@Prop() selectedTab: PopularTabType;
	@Prop() amount: number;

	@Constant.Getter providers: (filterUserProviders: boolean) => Provider[];
	@Routing.State activeRoute: any;
	get userProviders() {
		return this.providers(true);
	}

	providerPlans: Plan[] = [];

	// @Watch('provider', { immediate: true })
	// async onProviderChange() {
	// 	this.providerPlans = await loadProviderPlan(this.provider.shortName);
	// }

	async mounted() {
		this.$emit('done');
	}

	get newPageType() {
		return this.activeRoute?.meta?.newPageType;
	}
}
